@import 'styles/mixins';
@import 'styles/variables';

.nav {
  @include shadow-3;
  @include z-index(popover);
  background-color: $white;
  border: 1px solid var(--neutral-20);
  border-radius: 8px;
  padding: 4px;
  width: 245px;

  .navItem {
    color: var(--neutral-90);
    display: flex;
    justify-content: flex-start;
    width: 100%;
    border-radius: 4px;
    padding: 0 8px;
    gap: 8px;
    height: 32px;

    svg {
      color: var(--neutral-50);
    }

    .toggle {
      margin-left: auto;
    }
  }

  .divider {
    background-color: var(--neutral-20);
    height: 1px;
    margin: 10px 0;
    width: 100%;
  }

  .selectedCount {
    color: var(--action-50);
    font-weight: 500;
    padding: 8px 0px;
  }
}

.locationPickerContainer {
  @include shadow-3;
  @include z-index(popover);
  background-color: $white;
  border: 4px solid var(--neutral-20);
  border-radius: 8px;
  padding: 4px;
}

.successMessage {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 480px;
}

.loadingMessage {
  @include md-medium;
  align-items: center;
  display: flex;
  padding: 12px;
  color: var(--neutral-90);
  background-color: var(--neutral-0);
  border-radius: 12px;

  svg {
    margin-right: 10px;
  }
}

.handbookIcon {
  fill: none;
  width: 16px;
  height: 16px;
  stroke: var(--neutral-30);
}

.menuDivider {
  border-top: solid 1px var(--neutral-10);
  margin: 4px 2px;
}
